<template>
  <div>
    <BaseTopLine></BaseTopLine>

    <!-- <div
      class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px]"
    >
      <div class="tw-flex tw-gap-[15px]">
        <button @click="changeShowMessages(true)" class="tw-app-btn-primary">
          {{ dataLang["notification_page_text1"] }}
        </button>
        <button @click="changeShowMessages(false)" class="tw-app-btn-primary">
          {{ dataLang["notification_page_text2"] }}
        </button>
      </div>
    </div> -->

    <div class="tw-relative tw-mb-[15px] tw-bg-[#33497B]">
      <vue-tabs
        v-model="activateTab"
        @tab-change="changeShowMessages(!$event)"
        class="vue-tabs-type-1"
      >
        <v-tab :title="dataLang['notification_page_text1']" />
        <v-tab :title="dataLang['notification_page_text2']" />
      </vue-tabs>
    </div>

    <div class="tw-px-[26px]">
      <div class="tw-flex tw-justify-between tw-my-[15px]">
        <button @click="actionForEditTable" class="tw-app-btn-primary-outline">
          <span v-if="isReadedShow">
            {{ dataLang["notification_page_text3"] }}
          </span>
          <span v-if="!isReadedShow">
            {{ dataLang["notification_page_text11"] }}
          </span>
        </button>

        <TwBasePagination
          :page-count="Math.ceil(paginationInfo.total / paginationInfo.limit)"
          :pagination-params="paginationInfo"
          @updateLimitValue="(paginationInfo.limit = $event), clickLoadData(1)"
          :page-range="10"
          :click-handler="clickLoadData"
        >
        </TwBasePagination>
      </div>

      <ve-table
        class="fixed-header rest-style-table"
        style="width: 100%"
        :columns="isReadedShow ? columnsNotReaded : columns"
        :table-data="dataTable"
        :border-x="true"
        :border-y="true"
        ref="refTable"
        row-key-field-name="notices__id"
        :checkbox-option="{
          hideSelectAll: false,
          selectedRowChange: selectedRowChange,
          selectedAllChange: selectedAllChange,
        }"
        :eventCustomOption="eventCustomOption"
        v-if="!localLoading"
        :clickHighlight="false"
        :rowStyleOption="{
          hoverHighlight: true,
        }"
        :cellSelectionOption="{ enable: false }"
      />
    </div>

    <BaseModal
      name="showInfoNotice"
      width="640"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('showInfoNotice')"
        ></button>

        <div class="tw-text-[14px]">
          <div class="tw-app-modal__title">
            {{
              isReadedShow
                ? dataLang["notification_page_text9"]
                : dataLang["notification_page_text20"]
            }}
          </div>

          <div class="tw-grid tw-grid-cols-[145px_auto] tw-mb-[10px]">
            <div>
              {{ dataLang["notification_page_text4"] }}
            </div>
            <div class="tw-font-semibold">
              {{
                $time(textForModal?.notices__created_at)
                  .utc(true)
                  .utcOffset(Number(userSetting.company__utc))
                  .format(
                    `${userSetting.company__tempalte_date} ${userSetting.company__tempalte_time}`
                  )
              }}
            </div>
          </div>

          <div
            v-if="!isReadedShow"
            class="tw-grid tw-grid-cols-[145px_auto] tw-mb-[10px]"
          >
            <div>Время просмотра</div>
            <div class="tw-font-semibold">
              {{
                $time(textForModal?.notices__updated_at)
                  .utc(true)
                  .utcOffset(Number(userSetting.company__utc))
                  .format(
                    `${userSetting.company__tempalte_date} ${userSetting.company__tempalte_time}`
                  )
              }}
            </div>
          </div>

          <div class="tw-mb-[30px]">
            <div class="tw-app-input-type-3-label">
              {{ dataLang["notification_page_text7"] }}
            </div>
            <div
              class="tw-app-input-type-3 tw-h-[220px] tw-overflow-y-auto !tw-leading-[130%]"
              v-html="textForModal?.notices__text"
            ></div>
          </div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('showInfoNotice')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["notification_page_text12"] }}
            </button>
            <button
              @click="editAllAndOne(textForModal?.notices__id)"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{
                isReadedShow
                  ? dataLang["notification_page_text3"]
                  : dataLang["notification_page_text11"]
              }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="acceptDeletes"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="bg-transparent shadow-none"
    >
      <div class="bg-white rounded-25 py-25 px-20">
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn-close"
            @click="$modal.hide('acceptDeletes')"
          ></button>
        </div>
        <p class="text-center">{{ dataLang.confirm_dialog_delete }}</p>
        <div class="d-flex justify-content-center mt-10">
          <div class="btn btn-sm btn-danger" @click="deleteRow">
            {{ dataLang.confirm_btn__btn_yes }}
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import NoticesService from "@/api/NoticesService.js";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
export default {
  components: {
    VeTable,
    VueTabs,
    VTab,
  },

  props: {},
  data() {
    return {
      activateTab: "",
      updatedValues: {},
      isReadedShow: true,
      dataForModal: {},
      textForModal: null,
      editData: {},
      activeSelectRow: null,
      dataTable: null,
      activeSelectRowsMultiple: [],
      currentOpenIdModal: null,
      localLoading: true,
      sortOption: {
        sortChange: (params) => {
          this.sortChange(params);
        },
      },
      rowStyleOption: {
        stripe: true,
      },
      cellSelectionOption: {
        enable: false,
      },
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              this.$modal.show("showInfoNotice");
              this.textForModal = row;
            },
          };
        },
      },
      paginationInfo: {
        count: 0,
        limit: 50,
        total: 0,
        page: 0,
      },
    };
  },
  methods: {
    changeShowMessages(type) {
      this.isReadedShow = type;
      this.clickLoadData(1);
    },
    editAllAndOne(listOrOne) {
      this.localLoading = true;
      NoticesService.editMultiple(listOrOne, {
        statusCode: this.isReadedShow
          ? "notification_status_read"
          : "notification_status_new",
      })
        .then((data) => {
          this.localLoading = false;
          this.$toast.success(data.data.message);
          this.clickLoadData(1);
        })
        .catch((error) => {});
      this.$modal.hide("showInfoNotice");
    },
    actionForEditTable() {
      if (this.activeSelectRowsMultiple.length) {
        // this.$modal.show('showInfoNotice')

        this.editAllAndOne(this.activeSelectRowsMultiple);
      } else {
        this.$toast.error("Вы не выбрали ни одного поля", { duration: 5000 });
      }
    },
    // deleteRow(nameModal) {
    //   this.deleteTransportVehiclesData(this.activeSelectRowsMultiple)
    //   this.activeSelectRow = null
    //   this.$modal.hide('acceptDeletes')
    // },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    clickLoadData(numPage) {
      this.localLoading = true;
      this.paginationInfo.page = numPage;
      NoticesService.getAll({
        params: {
          limit: this.paginationInfo.limit,
          page: this.paginationInfo.page,
          where: JSON.stringify([
            {
              field: "notices_statuses__status",
              value: this.isReadedShow
                ? "notification_status_new"
                : "notification_status_read",
            },
          ]),
        },
      })
        .then((data) => {
          this.localLoading = false;
          this.dataTable = data.data.data.rows;

          this.paginationInfo.count = data.data.data.count;
          this.paginationInfo.limit = data.data.data.limit;
          this.paginationInfo.total = data.data.data.total;
          this.paginationInfo.page = data.data.data.page;
        })
        .catch((error) => {});
      this.setUserNotification();
    },

    deleteRow(nameModal) {
      this.localLoading = true;
      NoticesService.delete(this.activeSelectRowsMultiple)
        .then((data) => {
          this.$toast.success(data.data.message);

          NoticesService.getAll({
            params: {
              where: JSON.stringify([
                { field: "request_services__type_service_id", value: 2 },
              ]),
            },
          })
            .then((data) => {
              this.localLoading = false;
              this.dataTable = data.data.data.rows;
            })
            .catch((error) => {});
        })
        .catch((error) => {
          //   this.validateData(error.response.data.errors)
          //   this.$toast.error(error.response.data.message, {duration: 5000})
          //   callback(false, nameTab, oldTab, newTab)
        });

      this.activeSelectRowsMultiple = [];
      this.$modal.hide("acceptDeletes");
      //   this.localLoading = false
    },

    updateValue(data) {
      this.updatedValues[data.name] = data.value;
    },

    ...mapActions("userSettingModule", [
      "getUserSetting",
      "setUserNotification",
    ]),
  },
  mounted() {
    dayjs.extend(utc);
  },

  created() {
    // ?where=[{"field":"request_services__type_service_id","value":8}]
    this.clickLoadData(1);
    // this.getBidsOsagoAll({
    //   params: {
    //     page: 1,
    //     limit: 10,
    //   },
    // })
  },

  computed: {
    ...mapState("userSettingModule", ["userSetting", "countNotices"]),
    ...mapState("translationModule", ["dataLang"]),
    columnsNotReaded() {
      return [
        {
          field: "",
          key: "a",

          type: "checkbox",
          title: "",
          width: "3%",
          align: "center",
        },
        {
          field: "notices__created_at",
          key: "2",
          title: this.dataLang["notification_page_text5"],
          width: "10%",
          align: "left",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.notices__created_at
                  ? dayjs(row.notices__created_at)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(
                        `${this.userSetting.company__tempalte_date} HH:mm`
                      )
                  : ""}
              </span>
            );
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={""}>
                  {this.isReadedShow
                    ? this.dataLang["notification_page_text4"]
                    : this.dataLang["notification_page_text5"]}
                </div>
              </div>
            );
          },
        },
        {
          field: "notices_categories__event",
          key: "3",
          title: this.dataLang["notification_page_text6"],
          align: "left",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return <span>{this.dataLang[row.notices_categories__event]}</span>;
          },
        },
        {
          field: "notices__text",
          key: "4",
          title: this.dataLang["notification_page_text7"],
          align: "left",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            // return <span>{row.notices__text}</span>
            return h("span", {
              domProps: {
                innerHTML: row.notices__text,
              },
            });
          },
        },
        {
          field: "employees__name",
          key: "5",
          title: this.dataLang["notification_page_text8"],
          align: "left",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>
                  {this.isReadedShow
                    ? "Нажмите"
                    : this.dataLang["notification_page_text8"]}
                </div>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <div class={"d-flex justify-content-center"}>
                {this.isReadedShow ? (
                  <button
                    class={"tw-app-btn-primary"}
                    on-click={() => this.editAllAndOne(row.notices__id)}
                  >
                    Просмотрено
                  </button>
                ) : (
                  row.employees__name
                )}
              </div>
            );
          },
        },
      ];
    },
    columns() {
      return [
        {
          field: "",
          key: "a",

          type: "checkbox",
          title: "",
          width: "3%",
          align: "center",
        },

        {
          field: "notices__created_at",
          key: "2",
          title: this.dataLang["notification_page_text5"],
          align: "left",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.notices__created_at
                  ? dayjs(row.notices__created_at)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(
                        `${this.userSetting.company__tempalte_date} HH:mm`
                      )
                  : ""}
              </span>
            );
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={""}>
                  {this.isReadedShow
                    ? this.dataLang["notification_page_text4"]
                    : this.dataLang["notification_page_text5"]}
                </div>
              </div>
            );
          },
        },
        {
          field: "notices__updated_at",
          key: "22",
          title: this.dataLang["notification_page_text555"],
          align: "left",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return !this.isReadedShow ? (
              <span>
                {row.notices__updated_at
                  ? dayjs(row.notices__updated_at)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(
                        `${this.userSetting.company__tempalte_date} HH:mm`
                      )
                  : ""}
              </span>
            ) : (
              ""
            );
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={""}>{column.title}</div>
              </div>
            );
          },
        },
        {
          field: "notices_categories__event",
          key: "3",
          title: this.dataLang["notification_page_text6"],
          align: "left",
          width: "10%",
          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return <span>{this.dataLang[row.notices_categories__event]}</span>;
          },
        },
        {
          field: "notices__text",
          key: "4",
          title: this.dataLang["notification_page_text7"],
          align: "left",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            // return <span>{row.notices__text}</span>
            return h("span", {
              domProps: {
                innerHTML: row.notices__text,
              },
            });
          },
        },
        {
          field: "employees__name",
          key: "5",
          title: this.dataLang["notification_page_text8"],
          align: "left",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>
                  {this.isReadedShow
                    ? "Нажмите"
                    : this.dataLang["notification_page_text8"]}
                </div>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <div class={"d-flex justify-content-center"}>
                {this.isReadedShow ? (
                  <button
                    class={"tw-app-btn-primary"}
                    on-click={() => this.editAllAndOne(row.notices__id)}
                  >
                    Просмотрено
                  </button>
                ) : (
                  row.employees__name
                )}
              </div>
            );
          },
        },
      ];
    },
  },
};
</script>
